var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        {
          staticClass: "filter-container",
          staticStyle: { "margin-bottom": "15px" },
        },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "260px" },
            attrs: {
              placeholder: _vm.$t("savedRoutes.searchPlaceholder"),
              clearable: "",
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.listQuery.search,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "search", $$v)
              },
              expression: "listQuery.search",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "160px", "margin-left": "10px" },
              attrs: {
                clearable: "",
                placeholder: _vm.$t("savedRoutes.visibility"),
              },
              model: {
                value: _vm.listQuery.visibility,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "visibility", $$v)
                },
                expression: "listQuery.visibility",
              },
            },
            [
              _c("el-option", {
                attrs: { label: _vm.$t("savedRoutes.all"), value: "" },
              }),
              _c("el-option", {
                attrs: {
                  label: _vm.$t("savedRoutes.visibilityPrivate"),
                  value: "private",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: _vm.$t("savedRoutes.visibilityPublic"),
                  value: "public",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.fetchList },
            },
            [_vm._v(" " + _vm._s(_vm.$t("savedRoutes.refresh")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: { float: "right" },
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function ($event) {
                  _vm.createVisible = true
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("savedRoutes.create")) + " ")]
          ),
        ],
        1
      ),
      _c("route-form-dialog", {
        attrs: { visible: _vm.createVisible },
        on: {
          "update:visible": function ($event) {
            _vm.createVisible = $event
          },
          saved: _vm.fetchList,
        },
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.title"),
              prop: "title",
              "min-width": "140",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.user"),
              prop: "userEmail",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.visibility"),
              width: "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            row.visibility === "public" ? "success" : "info",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.visibility === "public"
                                ? _vm.$t("savedRoutes.visibilityPublic")
                                : _vm.$t("savedRoutes.visibilityPrivate")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.start"),
              prop: "startAddress",
              "min-width": "160",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.end"),
              prop: "endAddress",
              "min-width": "160",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.distance"),
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.formatDistance(row.distanceM)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.duration"),
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.formatDuration(row.durationSec)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.date"),
              width: "160",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.formatDate(row.createdAt)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("savedRoutes.actions"),
              width: "220",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type:
                            row.visibility === "public" ? "warning" : "success",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleVisibility(row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.visibility === "public"
                                ? _vm.$t("savedRoutes.makePrivate")
                                : _vm.$t("savedRoutes.makePublic")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("el-button", {
                      attrs: {
                        size: "mini",
                        type: "danger",
                        icon: "el-icon-delete",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleDelete(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("template", { slot: "empty" }, [
            _vm._v(_vm._s(_vm.$t("savedRoutes.empty"))),
          ]),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { "margin-top": "15px", "text-align": "right" },
        attrs: {
          background: "",
          layout: "total, prev, pager, next",
          total: _vm.total,
          "page-size": _vm.listQuery.limit,
          "current-page": _vm.page,
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.page = $event
          },
          "update:current-page": function ($event) {
            _vm.page = $event
          },
          "current-change": _vm.fetchList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }